import { graphql, useFragment } from "react-relay";
import {
  HasPermission,
  usePermissions_store$key,
} from "../../../../OS/Login/usePermissions";
import {
  AHIcon,
  AHText,
  Box,
  TouchableBox,
  useLayoutContext,
  useTheme,
} from "arkh";
import { TeamScheduleEmpty } from "../TeamHome/TeamHomeDailySchedule";

import { isDarkColor } from "../TeamHome/isDarkColor";
import { FormattedMessage } from "react-intl";

import { TeamSchedule } from "../TeamSchedule/TeamSchedule";
import { TeamTeamSchedule_team$key } from "./__generated__/TeamTeamSchedule_team.graphql";
import React from "react";

export const TeamTeamSchedule = React.memo(TeamTeamScheduleC);
function TeamTeamScheduleC(props: {
  team: TeamTeamSchedule_team$key;
  navigation: any;
  store: usePermissions_store$key;
}) {
  const team = useFragment(
    graphql`
      fragment TeamTeamSchedule_team on Team {
        id
        color
        dailySchedule: currentTeamSchedule(freq: DAILY) {
          id
          isActive
        }
        weeklySchedule: currentTeamSchedule(freq: WEEKLY) {
          id
          isActive
        }
        monthlySchedule: currentTeamSchedule(freq: MONTHLY) {
          id
          isActive
        }
      }
    `,
    props.team
  );
  const layout = useLayoutContext();
  const theme = useTheme();
  const teamColor = team.color ?? theme.primary;
  const teamScheduleEmpty =
    !(team.dailySchedule?.isActive ?? false) &&
    !(team.weeklySchedule?.isActive ?? false) &&
    !(team.monthlySchedule?.isActive ?? false);

  return (
    <Box
      style={{
        width: "45%",
      }}
    >
      {teamScheduleEmpty ? (
        <Box spaceTop="medium">
          <TeamScheduleEmpty />
          <HasPermission permission="ROUTINE_ADMIN" store={props.store}>
            <TouchableBox
              style={{
                marginTop: layout.space.medium,
                height: 30,
                borderRadius: 20,
                backgroundColor: teamColor,
                alignSelf: "center",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "100%",
              }}
              onPress={() => {
                props.navigation.navigateDeprecated("TeamScheduleAdmin", {
                  teamId: team.id,
                });
              }}
              spaceHorizontal="medium"
            >
              <AHText
                type="title-small"
                numberOfLines={1}
                color={
                  isDarkColor(teamColor) ? "text-inverted" : "text-primary"
                }
              >
                <FormattedMessage
                  description="Team home empty routine screen get started button title"
                  defaultMessage="Get started with routines"
                />
              </AHText>
              <AHIcon
                type="arrow-right"
                color={
                  isDarkColor(teamColor) ? "text-inverted" : "text-primary"
                }
                spaceLeft="xsmall"
              />
            </TouchableBox>
          </HasPermission>
        </Box>
      ) : (
        <TeamSchedule
          paddingTop="small"
          onOpenHistory={(currentId, freq) => {
            props.navigation.navigateDeprecated("TeamScheduleHistory", {
              currentId,
              freq,
              teamId: team.id,
            });
          }}
          onRequestNow={() => () => {}}
          teamId={team.id}
        />
      )}
    </Box>
  );
}
